import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { TranslocoModule } from '@ngneat/transloco';
import { SvcControlsModule } from '@solvace/component/svc-controls';
import { SvcButtonsModule } from '@solvace/component/svc-buttons';
import { SvcAudioToTextButtonModule } from '@solvace/feature/general/svc-audio-to-text-button';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';

export interface SvcActionPlanRescheduleModalData {
  dueDate: string | null;
  showVoiceToTextButton?: boolean;
}

export interface SvcActionPlanRescheduleModalResult {
  dueDate: string | null;
  comment: string;
}

@Component({
  selector: 'svc-action-plan-reschedule-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    TranslocoModule,
    SvcControlsModule,
    SvcButtonsModule,
    SvcAudioToTextButtonModule,
    LibSharedCommonModule,
  ],
  templateUrl: './svc-action-plan-reschedule-modal.component.html',
  styleUrls: ['./svc-action-plan-reschedule-modal.component.scss'],
})
export class SvcActionPlanRescheduleModalComponent {
  public form: FormGroup;
  public showVoiceToTextButton = true;
  public minDate: Date;

  constructor(
    private _formBuilder: FormBuilder,
    private _dialogRef: MatDialogRef<SvcActionPlanRescheduleModalComponent, SvcActionPlanRescheduleModalResult>,
    @Inject(MAT_DIALOG_DATA) public data: SvcActionPlanRescheduleModalData
  ) {
    this.showVoiceToTextButton = this.data?.showVoiceToTextButton ?? true;
    this.minDate = this.#startOfToday();

    this.form = this._formBuilder.group({
      dueDate: [this.data?.dueDate ?? null, Validators.required],
      comment: ['', [Validators.maxLength(200)]],
    });
  }

  #startOfToday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  public get isChangeDisabled(): boolean {
    return this.form?.invalid;
  }

  public onClose(): void {
    this._dialogRef.close();
  }

  public onChange(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this._dialogRef.close({
      dueDate: this.form?.controls?.['dueDate']?.value ?? null,
      comment: this.form?.controls?.['comment']?.value ?? '',
    });
  }
}

